'use strict';

import { mapGetters } from 'vuex';

export default {
  name: 'ThemeMixin',

  computed: {
    ...mapGetters('themes', ['isHighContrastThemeActive', 'selectedThemeName']),

    THEME_CSS_VARS() {
      return {
        '--font-color': this.isHighContrastThemeActive ? 'black' : 'inherit',
        '--primary-button-font-color': this.isHighContrastThemeActive ? 'black' : 'white',
        '--subtitle-font-color': this.isHighContrastThemeActive ? '#ffff01' : 'inherit',
        '--icon-text-font-color': this.selectedThemeName === 'default' ? 'inherit' : '#ffffffb3'
      };
    }
  },

  methods: {
    getSideBarActionsColor(isHover) {
      let color;
      if (isHover && !this.isHighContrastThemeActive) {
        color = 'primary';
      } else if (isHover && this.isHighContrastThemeActive) {
        color = 'black';
      } else {
        color = 'grey lighten-1';
      }

      return color;
    },
    getCustomScrollStyle() {
      const color1 = this.selectedThemeName === 'default' ?
        'var(--v-surface-darken1)' : 'var(--v-surface-lighten1)';
      const color3 = this.selectedThemeName === 'default' ?
        'var(--v-surface-darken3)' : 'var(--v-surface-lighten3)';
      return `.tabpanel {
          -webkit-overflow-scrolling: touch;
          overflow-y: auto;
        }

        .tabpanel::-webkit-scrollbar {
          width: 10px;
        }

        .tabpanel::-webkit-scrollbar-track {
          background-color: ${color1};
        }
        .tabpanel::-webkit-scrollbar-thumb {
          background-color: ${color3};
          border: 2px solid ${color1};
          border-radius: 6px;
        }
        .tabpanel::-webkit-scrollbar-thumb:hover {
          border: 1px solid ${color1};
        }
        .tabpanel::-webkit-scrollbar-button {
          display: none;
        }`;
    }
  }
};
